import React from "react";
import styled from "styled-components";

import * as u from "../utils";
import * as I from "./Icons";

export default function Search(props) {
  const initialValue = props?.initialValue ?? "";
  const [searchText, setSearchText] = React.useState(initialValue);

  React.useEffect(() => {
    setSearchText(initialValue);
  }, [initialValue]);
  React.useEffect(onSearchChange, [searchText]);
  const dataCy = "search-input" + (props.name ? "-" + props.name : "");
  return (
    <S.SearchContainer>
      <S.SearchInput
        onChange={(e) => setSearchText(e.target.value)}
        value={searchText}
        placeholder={props.placeholder || "Search"}
        data-cy={dataCy}
      />
      {!searchText && <S.SearchIcon />}
      {searchText && (
        <S.CloseIcon
          onClick={clearSearch}
          data-cy={"search-close-" + props.name}
        />
      )}
    </S.SearchContainer>
  );

  function onSearchChange() {
    if (props.delay) {
      if (searchText.length < 3 && !props.initialValue) props.onSearch("");
      const id = setTimeout(onSubmit, 500);
      return () => {
        clearTimeout(id);
      };
    }
    props.onSearch(searchText);
  }

  async function onSubmit() {
    props.onSearch(searchText);
  }

  function clearSearch() {
    setSearchText("");
    return;
  }
}

const S = {};

S.SearchContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 280px;
`;

S.SearchInput = styled.input.attrs(() => ({
  $autoCorrect: false,
}))`
  height: 40px;
  font-size: 14px;
  border-radius: 2px;
  padding: 10px;
  padding-left: 0px;
  border: none;
  width: 70%;
  position: relative;

  &:focus-visible {
    outline: -webkit-focus-ring-color auto 0px;
  }

  &::placeholder {
    font-weight: 700;
    color: ${u.colours.charcoal};
    opacity: 1;
  }
`;

S.SearchIcon = styled(I.Search)`
  position: absolute;
  color: ${u.colours.charcoal};
  top: 8px;
  right: 14px;
`;

S.CloseIcon = styled(I.Close)`
  position: absolute;
  color: ${u.colours.charcoal};
  right: 10px;
  top: 8px;
`;
